import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import StoryCard from "./../shared/story-card";
import Breadcrumb from "./../shared/breadcrumbs";
import styles from "../text-story-page/styles.m.css";
import stylesListicle from "./styles.m.css";
import Icon from "../../../../atoms/icon";
import { DfpAd } from "../../../../atoms/dfp-ad";
import ImageCaption from "../shared/elements/image-caption";
import ResponsiveImageWithFallback from "../../../../atoms/responsive-image-with-fallback";
import { generateImageSources } from "../../../../utils/utils";
import { isPremium } from "../../../../../../isomorphic/data/story";

const ListicleStoryImageElement = ({ element }) => {
  return (
    <div className={`${stylesListicle["listicle-image"]}`}>
      <ResponsiveImageWithFallback
        className={stylesListicle["image-listicle"]}
        slug={element["image-s3-key"]}
        metadata={element["image-metadata"]}
        alt={element["image-caption"]}
        imgParams={{ auto: ["format", "compress"] }}
        sources={generateImageSources(
          { aspectRatio: [16, 9], screenWidthCoverage: 1 },
          { aspectRatio: [16, 9], screenWidthCoverage: 0.5 }
        )}
      />
      <ImageCaption element={element} />
    </div>
  );
};

ListicleStoryImageElement.propTypes = {
  element: {
    "image-s3-key": PropTypes.string,
    "image-metadata": PropTypes.string,
    "image-caption": PropTypes.string,
    "image-attribution": PropTypes.string
  }
};

function ListicleStory(props) {
  const renderSocialMedia = get(props, ["renderSocialMedia"], () => null);
  const renderHeaderCard = get(props, ["renderHeaderCard"], () => null);
  const renderFooter = get(props, ["renderFooter"], () => null);
  const renderSidebar = get(props, ["renderSidebar"], () => null);
  const section = get(props, ["story", "sections", "0"], null);
  const cardsToBeNumbered = get(props, ["story", "cards"], []).filter(card => card["card-type"] !== "introduction")
    .length;
  let cardIndex = props.story["bullet-type"] === "123" ? 1 : 0;

  const renderBullet = card => {
    if (card["card-type"] !== "introduction") {
      return (
        <div className={stylesListicle["bullet"]}>
          {props.story["bullet-type"] === "123" ? (
            <span className={stylesListicle["bullet-text"]}>{cardIndex++}</span>
          ) : props.story["bullet-type"] === "321" ? (
            <span className={stylesListicle["bullet-text"]}>{cardsToBeNumbered - cardIndex++}</span>
          ) : (
            <Icon type={"bullet-arrow"} className={stylesListicle["bullet-icon"]} />
          )}
        </div>
      );
    } else {
      return null;
    }
  };

  return (
    <div className={`main-page ${stylesListicle.base} js-story-main-container`}>
      {!isPremium(props.story) && (
        <DfpAd story={props.story} className="hidden-mobile ad-tower-left" adtype="Tower_Left" placement="all" />
      )}
      <div className="page-content">
        <div className={`container`}>
          <Breadcrumb subSection={section} config={props.config} />
        </div>
        <div className={`container ${styles["story-grid"]}`}>
          <div className={styles["main-content"]}>
            <article className={`${styles["story-body"]} ${stylesListicle["story-body"]} js-story`}>
              {renderHeaderCard({ className: stylesListicle["listicle-header"] })}
              {props.story.cards.map((card, index) => (
                <React.Fragment key={index}>
                  {index === 3 &&
                    !isPremium(props.story) && <DfpAd story={props.story} adtype="Inarticle_fork" placement="story" />}
                  <div key={card.id} className={stylesListicle["listicle-card-wrapper"]}>
                    {renderBullet(card, index)}
                    <StoryCard key={card.id} card={card} story={props.story} />
                    {index % 2 === 1 &&
                      !isPremium(props.story) && <DfpAd story={props.story} adtype="Rectangle" placement="story" />}
                  </div>
                </React.Fragment>
              ))}
              {renderFooter()}
            </article>
            {renderSocialMedia("show-desktop")}
          </div>
          {renderSidebar()}
        </div>
      </div>
      {!isPremium(props.story) && (
        <DfpAd story={props.story} className="hidden-mobile ad-tower-right" adtype="Tower_Right" placement="all" />
      )}
    </div>
  );
}
const story = PropTypes.shape({
  id: PropTypes.string,
  authors: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      slug: PropTypes.string,
      "avatar-url": PropTypes.string,
      "avatar-s3-key": PropTypes.string,
      "twitter-handle": PropTypes.string,
      bio: PropTypes.string
    })
  ),
  contributors: PropTypes.arrayOf(
    PropTypes.shape({
      "role-name": PropTypes.string,
      authors: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string
        })
      )
    })
  ),
  headline: PropTypes.string.isRequired,
  alternative: PropTypes.shape({
    home: PropTypes.shape({
      default: PropTypes.shape({
        headline: PropTypes.string
      })
    })
  }),
  slug: PropTypes.string.isRequired,
  "hero-image-metadata": PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
    "aspect-ratio": PropTypes.arrayOf(PropTypes.number)
  }),
  "hero-image-s3-key": PropTypes.string,
  "hero-image-caption": PropTypes.string,
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      "card-type": PropTypes.string,
      metadata: PropTypes.shape({
        attributes: PropTypes.shape({
          imagealignment: PropTypes.array
        })
      }),
      "story-elements": PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string
        })
      )
    })
  ),
  "linked-stories": PropTypes.any
});
ListicleStory.propTypes = {
  story: story,
  config: Breadcrumb.propTypes.config,
  renderAuthorDetails: PropTypes.func,
  renderComments: PropTypes.func,
  renderReactions: PropTypes.func,
  renderSidebar: PropTypes.func,
  renderSocialMedia: PropTypes.func,
  renderTags: PropTypes.func
};

export { ListicleStory, ListicleStoryImageElement };
